import { makeObservable, observable } from 'mobx';
import { Ajax2 } from '@shared/Ajax';
import { Notify } from '@shared/ui-native/Notify';

export interface IAreaBalance {
    areaId: number;
    areaUuid: string;
    balance: {
        materialId: number;
        volumeUnit: number;
        volume: number;
        volumeInitial: number;
    }[];
}

export class BalancesStore {
    @observable.shallow items: IAreaBalance[] = null;
    @observable isLoading: boolean = false;
    activePromise: Promise<any> = null;

    constructor() {
        makeObservable(this);
    }

    fetchAndSetAll = (): Promise<IAreaBalance[]> => {
        if (this.activePromise) return this.activePromise;
        this.isLoading = true;
        this.activePromise = this.fetch()
            .then((resp: any) => {
                this.items = resp;
            })
            .finally(() => {
                this.isLoading = false;
                this.activePromise = null;
            })
            .catch(Notify.error);

        return this.activePromise;
    };

    fetch = (areaUuid?: string): Promise<IAreaBalance[]> => {
        return Ajax2({
            url: kuura.getContextPath() + `/project_masshaul_area_balances.json`,
            params: {
                projectId: kuura.getProjectId(),
                areaUuids: [areaUuid],
            },
        }).then(resp => resp.balances);
    };

    getAreaBalanceByMaterial = (areaBalances: IAreaBalance['balance']) => {
        if (!areaBalances?.length) return [];

        const final: Record<
            string,
            {
                materialId: number;
                initial: {
                    1: number;
                    2: number;
                    3: number;
                };
                current: {
                    1: number;
                    2: number;
                    3: number;
                };
            }
        > = {};

        areaBalances.forEach(b => {
            if (!final[b.materialId]) {
                // unify by volume unit so its easier to show in table
                final[b.materialId] = {
                    materialId: b.materialId,
                    initial: {
                        1: null,
                        2: null,
                        3: null,
                    },
                    current: {
                        1: null,
                        2: null,
                        3: null,
                    },
                };
            }
            final[b.materialId].initial[b.volumeUnit] = b.volumeInitial;
            final[b.materialId].current[b.volumeUnit] = b.volume;
        });

        return Object.values(final);
    };
}
